module.exports = __webpack_public_path__ + "img/GAME_GLACIER1.600e67f2.jpg";